// extracted by mini-css-extract-plugin
export default {"marginTop":"CartError_marginTop__MYSnc","errorBox":"CartError_errorBox__lQO-j","link":"CartError_link__cZqem"};